/*
|--------------------------------------------------------------------------
| Form Upload
|--------------------------------------------------------------------------
*/

// This simply takes the value of the upload path from the hidden field and inserts it into the styled, visible field.


$("#freeform_cv0").change(function() {
$("#uploadFile").val(this.files && this.files.length ?
      this.files[0].name : this.value.replace(/^C:\\fakepath\\/i, ''));
})
